/* HD Logo 3D – echtes 3D-Goldlogo (Three.js), dreht sich beim Laden genau einmal und bleibt dann stehen.
   Die Form ist exakt aus dem Original-Logo vektorisiert. */
(function () {
  if (window.__HD_LOGO3D_LIVE__) return;
  window.__HD_LOGO3D_LIVE__ = true;

  var SHAPE = {"shapes":[{"outer":[[0.169,-0.6177],[0.0038,-0.4358],[-0.1674,-0.6162],[-1.0,0.2179],[-0.6078,0.6147],[0.6002,0.6177],[1.0,0.2194]],"holes":[[[0.0015,-0.2668],[0.4786,0.2286],[0.1873,0.5153],[-0.1919,0.5138],[-0.4771,0.2271],[-0.1743,-0.091]],[[-0.1682,-0.4396],[-0.0795,-0.3479],[-0.6376,0.2225],[-0.3502,0.5145],[-0.5528,0.5138],[-0.8379,0.2286]],[[0.1743,-0.4365],[0.8349,0.2286],[0.5512,0.5138],[0.3471,0.513],[0.6361,0.224],[0.0872,-0.3509]]]},{"outer":[[-0.068,-0.1101],[-0.156,-0.0206],[0.1101,0.2576],[-0.0826,0.4488],[0.0833,0.4526],[0.2752,0.2576]],"holes":[]}],"h":1.2355};
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadThree(cb) {
    if (window.THREE) return cb();
    var s = document.querySelector('script[data-hd-three]');
    if (!s) {
      s = document.createElement('script');
      s.src = THREE_URL; s.async = true; s.setAttribute('data-hd-three', '');
      document.head.appendChild(s);
    }
    s.addEventListener('load', function () { cb(); });
    s.addEventListener('error', function () { cb(new Error('three')); });
  }

  /* Studio-Umgebung für Reflexionen: dunkler Raum mit warmen Softboxen */
  function studioTexture(THREE) {
    var c = document.createElement('canvas'); c.width = 512; c.height = 256;
    var x = c.getContext('2d');
    var g = x.createLinearGradient(0, 0, 0, 256);
    g.addColorStop(0, '#2a2420'); g.addColorStop(0.5, '#15110d'); g.addColorStop(1, '#4a3520');
    x.fillStyle = g; x.fillRect(0, 0, 512, 256);
    function box(cx, cy, w, h, col, blur) {
      x.save(); x.filter = 'blur(' + blur + 'px)'; x.fillStyle = col;
      x.fillRect(cx - w / 2, cy - h / 2, w, h); x.restore();
    }
    box(128, 80, 110, 50, '#fff1d0', 8);  /* Hauptlicht vorne links */
    box(256, 110, 70, 40, '#b08040', 14); /* warme Front */
    box(0, 120, 60, 150, '#ffe0a8', 10);  /* Seitenlicht hinten */
    box(512, 120, 60, 150, '#ffe0a8', 10);
    box(384, 100, 70, 130, '#ffd28a', 10);/* Seitenlicht rechts */
    box(256, 26, 360, 16, '#fff8ea', 5);  /* Deckenstreifen */
    box(256, 215, 512, 50, '#8a6334', 18);/* warmer Boden */
    var t = new THREE.CanvasTexture(c);
    t.mapping = THREE.EquirectangularReflectionMapping;
    t.encoding = THREE.sRGBEncoding;
    return t;
  }

  function buildGeometry(THREE) {
    var geos = [];
    SHAPE.shapes.forEach(function (s) {
      var shape = new THREE.Shape(s.outer.map(function (p) { return new THREE.Vector2(p[0], p[1]); }));
      s.holes.forEach(function (h) {
        shape.holes.push(new THREE.Path(h.map(function (p) { return new THREE.Vector2(p[0], p[1]); })));
      });
      geos.push(new THREE.ExtrudeGeometry(shape, {
        depth: 0.16, bevelEnabled: true, bevelThickness: 0.025, bevelSize: 0.018, bevelSegments: 4, curveSegments: 1
      }));
    });
    geos.forEach(function (g) { g.translate(0, 0, -0.08); g.computeVertexNormals(); });
    return geos;
  }

  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function mount(box) {
    if (box.__hd3d) return; box.__hd3d = true;
    var fallback = box.querySelector('img');
    loadThree(function (err) {
      if (err || !window.THREE) { box.classList.add('is-still'); return; }
      var THREE = window.THREE;
      var canvas = document.createElement('canvas');
      var renderer;
      try {
        renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true, premultipliedAlpha: true });
      } catch (e) { box.classList.add('is-still'); return; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.0;
      renderer.setClearColor(0x000000, 0);

      var scene = new THREE.Scene();
      var pmrem = new THREE.PMREMGenerator(renderer);
      scene.environment = pmrem.fromEquirectangular(studioTexture(THREE)).texture;

      var gold = new THREE.MeshStandardMaterial({ color: 0xc8952f, metalness: 1, roughness: 0.3, envMapIntensity: 1.5 });
      var group = new THREE.Group();
      buildGeometry(THREE).forEach(function (g) { group.add(new THREE.Mesh(g, gold)); });
      group.rotation.x = -0.06;
      scene.add(group);

      var key = new THREE.DirectionalLight(0xffe7c0, 1.6); key.position.set(-2, 3, 4); scene.add(key);
      var sideL = new THREE.DirectionalLight(0xffd08a, 1.5); sideL.position.set(-5, 0.5, 0); scene.add(sideL);
      var sideR = new THREE.DirectionalLight(0xffd08a, 1.5); sideR.position.set(5, 0.5, 0); scene.add(sideR);
      var rim = new THREE.DirectionalLight(0xffc870, 1.0); rim.position.set(0, 2, -4); scene.add(rim);
      var under = new THREE.DirectionalLight(0xffc77a, 0.9); under.position.set(0, -4, 3); scene.add(under);
      scene.add(new THREE.AmbientLight(0xffe2b0, 0.25));

      var camera = new THREE.PerspectiveCamera(26, 1, 0.1, 50);
      camera.position.set(0, 0, 5.2);

      function size() {
        var w = box.clientWidth, h = box.clientHeight;
        if (!w || !h) return;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        /* Logo (Breite 2) passt mit Rand in die Fläche */
        var fitW = 2.3 / (2 * Math.tan(camera.fov * Math.PI / 360) * camera.aspect);
        var fitH = (SHAPE.h + 0.3) / (2 * Math.tan(camera.fov * Math.PI / 360));
        camera.position.z = Math.max(fitW, fitH) + 0.1;
        camera.updateProjectionMatrix();
      }
      function render() { renderer.render(scene, camera); }

      box.appendChild(canvas);
      size(); render();
      box.classList.add('is-live');
      if (fallback) fallback.setAttribute('aria-hidden', 'true');

      var ro = window.ResizeObserver ? new ResizeObserver(function () { size(); render(); }) : null;
      if (ro) ro.observe(box);

      var DUR = 2600, started = false;
      function spin() {
        if (started || reduce) return;
        if (document.hidden) return;
        started = true;
        var t0 = performance.now();
        (function frame(now) {
          var k = Math.min(1, (now - t0) / DUR);
          group.rotation.y = easeInOut(k) * Math.PI * 2;
          render();
          if (k < 1) requestAnimationFrame(frame);
          else {
            group.rotation.y = 0; render();
            box.setAttribute('data-spun', '1');
            box.dispatchEvent(new CustomEvent('hd:logo-spun', { bubbles: true }));
          }
        })(t0);
      }
      box.__hdSpin = function () { started = false; spin(); };
      box.__hdRender = function (angle) { group.rotation.y = angle || 0; render(); return canvas; };
      var delay = Number(box.getAttribute('data-delay')) || 500;
      setTimeout(spin, delay);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) spin(); });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hd-logo3d-live]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
